import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { changePasswordLastStep } from "../../app/actions/authActions";
import { schemaValidateUserForgotPassword } from "../../app/data/schemaValidateUserForgotPassword";
import { debugLogPages } from "../../app/helpers/debugHelper";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import NewInputGenericRegister from "../generic-component/NewInputGenericRegister";
import NewInputGenericRegisterPassword from "../generic-component/NewInputGenericRegisterPassword";

const ForgotPasswordProcess = () => {
  debugLogPages('---> ForgotPasswordProcess');

  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { t } = useTranslation();

  const { userSelected } = useSelector((state) => state.user);

  const { values, errors, handleChange, handleSubmit } = useFormValidationsGeneric(
      () => registerCallback(),
      userSelected,
      schemaValidateUserForgotPassword
    );

  function registerCallback() {
    if(token){
       dispatch(changePasswordLastStep(token, values.password, navigate));
    }
  }

  return (
    <div className="gradient-custom-sky">
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-12 col-md-8 col-lg-10 col-xl-5">
            <div className="bg-color2 text-white" style={{ borderRadius: "1rem" }}>
              <form onSubmit={handleSubmit} noValidate>
                <div className="card-body p-5 text-center">
                  <div className="mb-md-5 mt-md-4 pb-5">
                    <h2 className="fw-bold mb-2 text-uppercase">{t("forgot-password-laststep.screen.title")}</h2>
                    <p className="text-white-50 mb-5">{t("forgot-password-laststep.screen.message")}</p>

                    <div className="row">
                      {/** Inicio formulario dinamico */}

                      {
                        schemaValidateUserForgotPassword && schemaValidateUserForgotPassword.length > 0 && (
                          schemaValidateUserForgotPassword.map((techSecondary, index) => {
                            
                            let varField = techSecondary.field;

                            if (techSecondary.component_new === "NewInputGenericRegister") {
                              return (
                                <NewInputGenericRegister
                                  key={techSecondary.id}
                                  handleChange={handleChange}
                                  values={values}
                                  errors={errors}
                                  placeholderVal={techSecondary.is_placeholder}
                                  field={varField}
                                  max_length={techSecondary.max_length}
                                  moduleText={techSecondary.module_text}
                                  occupation={techSecondary.occupation_new}
                                />
                              );
                            } else if (techSecondary.component_new === "NewInputGenericRegisterPassword") {
                              return (
                                <NewInputGenericRegisterPassword
                                  key={techSecondary.id}
                                  handleChange={handleChange}
                                  values={values}
                                  errors={errors}
                                  placeholderVal={techSecondary.is_placeholder}
                                  field={varField}
                                  max_length={techSecondary.max_length}
                                  moduleText={techSecondary.module_text}
                                  occupation={techSecondary.occupation_new}
                                />
                              );
                            }else {
                              return (
                                <div>
                                </div>
                              )
                            }
                          })
                        )
                      }

                      {/** Fin formulario dinamico */}
                    </div>

                    <br />

                    <button className="btn btn-outline-light btn-lg px-5" type="submit">
                      {t("register.screen.button")}
                    </button>
                  </div>

                  <div>                    
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordProcess;
